import { FC, MouseEventHandler, useState } from "react";

interface SearchSuggestionListEmptyProps {
}

let currentSelected;
let feedbackOpen = false;
function timeout(delay: number) {
    return new Promise(res => setTimeout(res, delay));
}

function getCurrentSelected() {

    currentSelected = document.getElementById("feedbackType")?.getAttribute('value');
}

async function clickNegativeButton() {

    const negativeButton = document.getElementById("negative");

    negativeButton?.addEventListener('click', function (e) {
        e.preventDefault();
    })
    negativeButton?.style.setProperty("scroll-behavior", "smooth !important")
    negativeButton?.scrollIntoView({ behavior: 'smooth' });

    negativeButton?.click();
    await timeout(500);
    await getCurrentSelected();
}

const scrollToFeedback: MouseEventHandler<HTMLAnchorElement> = async (event) => {
    // To keep the feedback button keyboard accessible, it must have an href attribute.
    // However, we don't want the browser to navigate to the feedback page, so we prevent the default behavior.
    event.preventDefault();
    event.stopPropagation();

    const feedbackElement = document.getElementById("feedbackElement");

    await clickNegativeButton();
    feedbackElement?.scrollIntoView({ behavior: "smooth" });

}



const SearchSuggestionListEmpty: FC<SearchSuggestionListEmptyProps> = (props) => {

    return (
        <a id="noSuggestionsStyleTweak" className="message-holder" onClick={scrollToFeedback}>
            There are no suggested questions in Ask Alice based on your searched keyword or question.
        </a>
    );
}

export default SearchSuggestionListEmpty;